import React from "react";

const Razor_Syntax = () => {
  return (
    <div className="tutorial-page">
      <h1>Razor Syntax</h1>
      <p>This is the Razor Syntax page content.</p>
    </div>
  );
};

export default Razor_Syntax;
